
import DateRangeValidation from './date-range-validation';

class UsageReports extends DateRangeValidation {
	constructor(config) {
		super(config);
		this.config = config;
	}
}

export default UsageReports;
